/**
 * Cloud Functions base URL for this project.
 * Override with REACT_APP_FUNCTIONS_URL in .env (e.g. for emulator).
 */
const PROJECT_ID = "quote-installation";
const REGION = "us-central1";

export const FUNCTIONS_BASE_URL =
  process.env.REACT_APP_FUNCTIONS_URL ||
  `https://${REGION}-${PROJECT_ID}.cloudfunctions.net`;

export const FUNCTIONS = {
  hubspotOAuthConnect: `${FUNCTIONS_BASE_URL}/hubspot_oauth_connect_fn`,
  slackOAuthConnect: `${FUNCTIONS_BASE_URL}/slack_oauth_connect_fn`,
  stripeCheckout: `${FUNCTIONS_BASE_URL}/stripe_checkout_fn`,
  stripePortal: `${FUNCTIONS_BASE_URL}/stripe_portal_fn`,
  getHubspotOptions: `${FUNCTIONS_BASE_URL}/get_hubspot_options_fn`,
  getTeamMembers: `${FUNCTIONS_BASE_URL}/get_team_members_fn`,
};

/** HubSpot OAuth */
export const HUBSPOT_CLIENT_ID =
  process.env.REACT_APP_HUBSPOT_CLIENT_ID;

export const HUBSPOT_REDIRECT_URI =
  process.env.REACT_APP_HUBSPOT_REDIRECT_URI ||
  (typeof window !== "undefined"
    ? `${window.location.origin}/auth-hubspot`
    : "https://quote-installation.web.app/auth-hubspot");

export const HUBSPOT_SCOPE = [
  "oauth",
  "crm.objects.quotes.read",
  "crm.objects.quotes.write",
  "crm.schemas.quotes.read",
  "crm.objects.line_items.read",
  "crm.objects.line_items.write",
  "crm.schemas.line_items.read",
  "crm.objects.deals.read",
  "crm.objects.deals.write",
  "crm.schemas.deals.read",
  "crm.objects.contacts.read",
  "crm.objects.contacts.write",
  "crm.schemas.contacts.read",
  "crm.objects.companies.read",
  "crm.objects.companies.write",
  "crm.schemas.companies.read",
  "crm.objects.products.read",
  "crm.objects.owners.read",
  "crm.objects.users.read",
  "cms.domains.read",
].join("%20");

export const HUBSPOT_INSTALL_URL = `https://app.hubspot.com/oauth/authorize?client_id=${encodeURIComponent(HUBSPOT_CLIENT_ID)}&redirect_uri=${encodeURIComponent(HUBSPOT_REDIRECT_URI)}&scope=${HUBSPOT_SCOPE}`;

/** Slack OAuth */
export const SLACK_CLIENT_ID =
  process.env.REACT_APP_SLACK_CLIENT_ID;

export const SLACK_SCOPES = "app_mentions:read,assistant:write,channels:history,channels:join,channels:read,chat:write,chat:write.public,commands,groups:history,groups:read,im:history,im:read,im:write,mpim:history,users:read,users:read.email";

/** Computed at call time so it always reflects the current origin (http vs https). */
export const getSlackInstallUrl = () => {
  const redirectUri =
    process.env.REACT_APP_SLACK_REDIRECT_URI ||
    `${window.location.origin}/auth-slack`;
  return `https://slack.com/oauth/v2/authorize?client_id=${encodeURIComponent(SLACK_CLIENT_ID)}&scope=${encodeURIComponent(SLACK_SCOPES)}&redirect_uri=${encodeURIComponent(redirectUri)}`;
};

/** LangGraph */
export const LANGGRAPH_API_URL =
  process.env.REACT_APP_LANGGRAPH_API_URL || `${FUNCTIONS_BASE_URL}/langgraph_proxy_fn`;
export const LANGGRAPH_ASSISTANT_ID =
  process.env.REACT_APP_LANGGRAPH_ASSISTANT_ID || "agent";
